export default function initialisePlurallFeedbackTracker() {
  window.PLURALL_TRACKER = new window.PlurallTracker({
    environment:
      process.env.NODE_ENV === "production" ? "production" : "staging",
    clientId: "adapta",
    plurallFeedback: 1001
  });
}
